(function(){
  var toast, toastTimer;
  function say(msg){
    toast = toast || document.getElementById('Toast');
    if(!toast) return;
    toast.textContent = msg; toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toast.hidden = true; }, 2400);
  }

  /* Swap the main gallery image.
     srcset/sizes must be cleared first: a responsive <img> keeps honouring its
     srcset candidates and ignores a new src, so the image would never change. */
  function setMainImage(url){
    if(!url) return;
    var main = document.querySelector('[data-gallery-main] img');
    if(!main) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = url;
  }

  /* ---- cart drawer ---- */
  var drawer = document.querySelector('[data-drawer]');
  function openDrawer(){ if(drawer){ drawer.classList.add('is-open'); document.body.style.overflow='hidden'; } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove('is-open'); document.body.style.overflow=''; } }

  async function refreshDrawer(){
    var res = await fetch(window.Shopify.routes.root + '?section_id=cart-drawer');
    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-drawer]');
    if(fresh && drawer){ drawer.innerHTML = fresh.innerHTML; }
    var counts = doc.querySelectorAll('[data-cart-count]');
    if(counts.length){
      var n = counts[0].textContent;
      document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = n; });
    }
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-drawer-open]')){ e.preventDefault(); openDrawer(); return; }
    if(e.target.closest('[data-drawer-close]')){ e.preventDefault(); closeDrawer(); return; }

    var qty = e.target.closest('[data-qty-step]');
    if(qty){
      e.preventDefault();
      var input = qty.parentElement.querySelector('input');
      var next = Math.max(1, (parseInt(input.value,10)||1) + parseInt(qty.dataset.qtyStep,10));
      input.value = next;
      input.dispatchEvent(new Event('change', {bubbles:true}));
      return;
    }

    var change = e.target.closest('[data-line-change]');
    if(change){
      e.preventDefault();
      updateLine(change.dataset.lineKey, change.dataset.lineChange);
      return;
    }

    /* thumbnails before zoom: a thumb click must not also toggle zoom */
    var thumb = e.target.closest('[data-thumb]');
    if(thumb){
      e.preventDefault();
      setMainImage(thumb.dataset.thumb);
      document.querySelectorAll('[data-thumb]').forEach(function(t){
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
      return;
    }

    var nav = e.target.closest('[data-gallery-nav]');
    if(nav){
      e.preventDefault();
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
      if(!thumbs.length) return;
      var at = thumbs.findIndex(function(t){ return t.getAttribute('aria-current') === 'true'; });
      if(at < 0) at = 0;
      var to = (at + parseInt(nav.dataset.galleryNav, 10) + thumbs.length) % thumbs.length;
      thumbs[to].click();
      return;
    }
  });

  async function updateLine(key, quantity){
    var res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id:key, quantity: quantity })
    });
    if(res.ok){
      if(document.body.classList.contains('template-cart')){ window.location.reload(); }
      else { await refreshDrawer(); }
    }
  }

  /* ---- add to cart ---- */
  document.addEventListener('submit', async function(e){
    var form = e.target.closest('[data-atc-form]');
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
    var data = new FormData(form);
    var res = await fetch(window.Shopify.routes.root + 'cart/add.js', { method:'POST', body:data });
    if(btn){ btn.disabled = false; btn.textContent = label; }
    if(res.ok){ await refreshDrawer(); openDrawer(); }
    else {
      var err = await res.json().catch(function(){ return {}; });
      say(err.description || 'Could not add to bag');
    }
  });

  /* ---- variant picker ---- */
  document.querySelectorAll('[data-variants]').forEach(function(root){
    var json = root.querySelector('[data-variant-json]');
    if(!json) return;
    var data = JSON.parse(json.textContent);

    root.addEventListener('change', function(){
      var chosen = Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function(group){
        var picked = group.querySelector('input:checked') || group.querySelector('select');
        return picked ? picked.value : null;
      });
      var match = data.find(function(v){
        return v.options.every(function(o,i){ return o === chosen[i]; });
      });

      var priceEl = root.querySelector('[data-variant-price]');
      var idEl = root.querySelector('[data-variant-id]');
      var btn = root.querySelector('[data-atc-button]');

      if(!match){
        if(btn){ btn.disabled = true; btn.textContent = 'Unavailable'; }
        return;
      }
      if(idEl) idEl.value = match.id;
      if(priceEl) priceEl.innerHTML = match.price;
      if(btn){
        btn.disabled = !match.available;
        btn.textContent = match.available ? (btn.dataset.addLabel || 'Add to bag') : 'Sold out';
      }
      if(match.image) setMainImage(match.image);

      if(history.replaceState){
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }
    });
  });

  /* ---- video tile sound toggle ---- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-video-sound]');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var video = btn.closest('.vtile').querySelector('video');
    if(!video) return;
    video.muted = !video.muted;
    if(!video.muted) video.play();
    btn.classList.toggle('is-live', !video.muted);
    btn.querySelector('[data-sound-off]').hidden = !video.muted;
    btn.querySelector('[data-sound-on]').hidden = video.muted;
    btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
  });

  /* ---- sticky buy bar ---- */
  var bar = document.querySelector('[data-stickybar]');
  if(bar){
    window.addEventListener('scroll', function(){
      bar.classList.toggle('is-in', window.scrollY > 620);
    }, {passive:true});
  }

  /* ---- gallery / events filters ---- */
  document.querySelectorAll('[data-filter-group]').forEach(function(group){
    var scope = document.querySelector(group.dataset.filterGroup);
    if(!scope) return;
    var empty = scope.querySelector('[data-filter-empty]');

    function apply(value){
      var shown = 0;
      scope.querySelectorAll('[data-filter-value]').forEach(function(item){
        var hit = value === 'all' || item.dataset.filterValue === value;
        item.hidden = !hit;
        if(hit) shown++;
      });
      if(empty) empty.hidden = shown > 0;
      group.querySelectorAll('[data-filter]').forEach(function(b){
        var on = b.dataset.filter === value;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    group.addEventListener('click', function(e){
      var btn = e.target.closest('[data-filter]');
      if(btn) apply(btn.dataset.filter);
    });
    if(empty){
      empty.addEventListener('click', function(e){
        if(e.target.closest('[data-filter-reset]')) apply('all');
      });
    }
  });
})();